import React, { useState, useEffect } from 'react'
import classnames from 'classnames'
import { createStructuredSelector } from 'reselect'

import Button from '@components/Button'

import DetailedCookies from 'cookies/components/DetailedCookies'
import { setCookies } from 'cookies/actions'
import { COOKIE_TYPE_ANALYTICS } from 'cookies/constants'
import { cookiesAcceptedSelector } from 'cookies/selectors'

import styles from './styles.module.scss'

const initialState = {
    [COOKIE_TYPE_ANALYTICS]: true,
}

const Cookies = ({ showSettings, setCookies, cookiesAccepted }) => {
    const [settingsOpen, setSettingsOpen] = useState(showSettings || false)
    const [cookieDetails, setCookieDetails] = useState(initialState)

    useEffect(() => {
        if (cookiesAccepted) {
            setCookieDetails(cookiesAccepted)
        }
    }, [cookiesAccepted])

    const acceptCookies = all => {
        setCookies(all ? initialState : cookieDetails)
    }

    const rejectCookies = () => {
        setCookies({})
    }

    const handleManageBtnClick = () => {
        if (!settingsOpen) {
            setSettingsOpen(true)
        } else {
            acceptCookies(false)
        }
    }

    return (
        <>
            {settingsOpen && <DetailedCookies cookieDetails={cookieDetails} setCookieDetails={setCookieDetails} />}
            <div className="d-md-flex justify-content-between align-items-center mt-6">
                <div className={classnames('d-sm-flex', styles.buttons)}>
                    <Button btnStyle="outline" size="small" className="mr-2 mr-md-3" onClick={handleManageBtnClick}>
                        {settingsOpen ? <T>cookie.modal.btn.save.selected</T> : <T>cookie.modal.btn.manage</T>}
                    </Button>
                    <Button onClick={() => acceptCookies(true)} size="small">
                        {settingsOpen ? <T>cookie.modal.btn.accept.all</T> : <T>cookie.modal.btn.accept</T>}
                    </Button>
                </div>
                <Button
                    btnStyle="link"
                    className={classnames('mt-3', 'mt-md-0', styles.rejectBtn)}
                    onClick={rejectCookies}>
                    <T>cookie.modal.btn.reject</T>
                </Button>
            </div>
        </>
    )
}

export default compose(
    withTranslate,
    connect(
        createStructuredSelector({
            cookiesAccepted: cookiesAcceptedSelector,
        }),
        { setCookies }
    )
)(Cookies)
